import Language from './language';

export default {
  components: { Language },
  // el: 'agent-item',
  props: ['item', 'use_view', "list"],
  methods: {
    detail: function(item) {
        // if(!item.alive) { return this.$toastr.e(e.data ? e.data.message : e.statusText)('The Server is Offline'); }
        var str = item.version;
        var strArray = str.split('.')
        this.$router.push(`modules/${strArray[0]}/${item.id}`);
    },
  },
  destroyed () { console.log('item.vue destroyed') },
  mounted () { console.log('item.vue mounted') },
}
